/* ============================================================
   Deep Dive Goggles — funnel interactions
   reveal-on-scroll · depth gauge · sticky buy bar ·
   pack selection · add-to-cart (Dawn cart drawer) · FAQ
   ============================================================ */
(function () {
  if (window.__ddgInit) return;
  window.__ddgInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmtMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.ddgMoneyFormat) {
        return Shopify.formatMoney(cents, window.ddgMoneyFormat);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(0);
  }

  /* ---------- reveal on scroll (+ staggered grids) ---------- */
  function initReveal() {
    var revs = document.querySelectorAll('.ddg-reveal, .ddg-stagger');
    if (!revs.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revs.forEach(function (r) { io.observe(r); });
    } else {
      revs.forEach(function (r) { r.classList.add('in'); });
    }
  }

  /* ---------- depth gauge + atmosphere + parallax on scroll ---------- */
  function initScroll() {
    var marker = document.getElementById('ddgGaugeMarker');
    var read = document.getElementById('ddgGaugeRead');
    var zoneEl = document.getElementById('ddgGaugeZone');
    var buybar = document.getElementById('ddgBuybar');
    var atmos = document.querySelector('.ddg-atmos');
    var depthEl = document.querySelector('[data-ddg-max-depth]');
    var maxDepth = depthEl ? (parseFloat(depthEl.getAttribute('data-ddg-max-depth')) || 15) : 15;
    var hero = document.querySelector('.ddg-hero');
    var parallaxEls = [].slice.call(document.querySelectorAll('.ddg-parallax'));
    var zones = [
      { upto: 0.18, name: 'Surface' },
      { upto: 0.45, name: 'Reef' },
      { upto: 0.75, name: 'Deep' },
      { upto: 1.01, name: 'Abyss' }
    ];
    var ticking = false;

    function zoneFor(p) {
      for (var i = 0; i < zones.length; i++) { if (p <= zones[i].upto) return zones[i].name; }
      return 'Abyss';
    }

    function update() {
      ticking = false;
      var max = document.body.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      if (p < 0) p = 0; if (p > 1) p = 1;
      if (marker) marker.style.top = (p * 100) + '%';
      if (read) read.textContent = (p * maxDepth).toFixed(1) + 'm';
      if (zoneEl) zoneEl.textContent = zoneFor(p);
      if (atmos) atmos.style.setProperty('--ddg-depth', p.toFixed(3));
      if (buybar) {
        var threshold = hero ? hero.offsetHeight * 0.9 : 600;
        if (window.scrollY > threshold) buybar.classList.add('show');
        else buybar.classList.remove('show');
      }
      if (!reduce) {
        for (var i = 0; i < parallaxEls.length; i++) {
          var el = parallaxEls[i];
          var speed = parseFloat(el.getAttribute('data-ddg-speed')) || 0.15;
          var rect = el.getBoundingClientRect();
          var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed * -1;
          el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
        }
      }
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- email-capture popup ---------- */
  function initPopup() {
    var modal = document.getElementById('ddgModal');
    if (!modal) return;
    var key = modal.getAttribute('data-ddg-key') || 'ddg_popup_seen';
    var delay = parseInt(modal.getAttribute('data-ddg-delay'), 10);
    if (isNaN(delay)) delay = 9000;
    var exitIntent = modal.getAttribute('data-ddg-exit') === 'true';
    var shown = false;

    function alreadySeen() { try { return localStorage.getItem(key) === '1'; } catch (e) { return false; } }
    function remember() { try { localStorage.setItem(key, '1'); } catch (e) {} }
    function open() { if (shown || alreadySeen()) return; shown = true; modal.classList.add('open'); }
    function close() { modal.classList.remove('open'); remember(); }

    if (!alreadySeen()) {
      if (delay >= 0) setTimeout(open, delay);
      if (exitIntent) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0) open();
        });
      }
    }
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-ddg-modal-close]') || e.target.classList.contains('ddg-modal__scrim')) {
        e.preventDefault(); close();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var form = modal.querySelector('form');
    if (form) form.addEventListener('submit', function () { remember(); });
  }

  /* ---------- bundle picker (tiers + per-mask colour → real masks by qty) ---------- */
  var TIER_NAME = { solo: 'Solo', buddy: 'Buddy', crew: 'Crew' };

  // Build cart line items from the chosen colours, using the two REAL variants
  // (variants.Y = yellow id, variants.B = blue id). A 2/3-pack = quantity 2/3 of
  // the real masks, so AutoDS fulfils each unit. The multi-pack price is applied
  // by an automatic Shopify discount at checkout (8% off 2+).
  function itemsFor(colours, variants) {
    var y = 0, i;
    for (i = 0; i < colours.length; i++) { if (colours[i] === 'Y') y++; }
    var b = colours.length - y;
    var items = [];
    if (y > 0 && variants.Y) items.push({ id: Number(variants.Y), quantity: y });
    if (b > 0 && variants.B) items.push({ id: Number(variants.B), quantity: b });
    return items;
  }

  function updateBuybar(label, priceText, itemsJson) {
    var bbPack = document.getElementById('ddgBbPack');
    var bbPrice = document.getElementById('ddgBbPrice');
    var bbBtn = document.getElementById('ddgBuybarBtn');
    if (bbPack) bbPack.textContent = label;
    if (bbPrice) bbPrice.textContent = priceText;
    if (bbBtn) bbBtn.setAttribute('data-ddg-items', itemsJson || '');
  }

  function initOneBuy(buy) {
    var offer = buy.closest('.ddg-offer');
    var mode = offer ? offer.getAttribute('data-ddg-mode') : 'bundle';
    var variants = {};
    var dataEl = offer ? offer.querySelector('[data-ddg-variants]') : null;
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || {}; } catch (e) {}
    }
    var prices = {
      solo: buy.getAttribute('data-now-solo') || '',
      buddy: buy.getAttribute('data-now-buddy') || '',
      crew: buy.getAttribute('data-now-crew') || ''
    };
    var mainBtn = offer ? offer.querySelector('[data-ddg-mainbuy]') : null;
    var slotHost = buy.querySelector('[data-ddg-colslots]');
    var priceNow = buy.querySelector('.ddg-buy__now');
    var priceWas = buy.querySelector('.ddg-buy__was');

    function currentColours(size) {
      var slots = buy.querySelectorAll('[data-ddg-colslot]');
      var arr = [];
      slots.forEach(function (slot) {
        var on = slot.querySelector('.ddg-colbtn.active');
        arr.push(on ? on.getAttribute('data-colour') : 'Y');
      });
      while (arr.length < size) { arr.push('Y'); }
      return arr.slice(0, size);
    }

    function recompute() {
      var tier = buy.getAttribute('data-tier');
      var size = parseInt(buy.getAttribute('data-size'), 10) || 1;
      var items = itemsFor(currentColours(size), variants);
      var itemsJson = JSON.stringify(items);
      var priceText = prices[tier] || '';
      if (mainBtn) mainBtn.setAttribute('data-ddg-items', itemsJson);
      if (priceNow && priceText) { priceNow.textContent = priceText; }
      if (mode === 'bundle') {
        updateBuybar(TIER_NAME[tier] + ' · ' + size + (size > 1 ? ' masks' : ' mask'), priceText, itemsJson);
      }
    }

    function buildSlots(size) {
      if (!slotHost) return; // single mode uses a static slot
      slotHost.innerHTML = '';
      for (var i = 0; i < size; i++) {
        var def = (i % 2 === 0) ? 'Y' : 'B';
        var slot = document.createElement('div');
        slot.className = 'ddg-colslot';
        slot.setAttribute('data-ddg-colslot', '');
        slot.innerHTML =
          '<span class="ddg-colslot__n">Mask ' + (i + 1) + '</span>' +
          '<div class="ddg-colrow">' +
            '<button type="button" class="ddg-colbtn' + (def === 'Y' ? ' active' : '') + '" data-colour="Y"><span class="ddg-colswatch ddg-colswatch--y"></span>Coral Yellow</button>' +
            '<button type="button" class="ddg-colbtn' + (def === 'B' ? ' active' : '') + '" data-colour="B"><span class="ddg-colswatch ddg-colswatch--b"></span>Ocean Blue</button>' +
          '</div>';
        slotHost.appendChild(slot);
      }
    }

    buy.querySelectorAll('.ddg-tier').forEach(function (tierBtn) {
      tierBtn.addEventListener('click', function () {
        buy.querySelectorAll('.ddg-tier').forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-checked', 'false'); });
        tierBtn.classList.add('active');
        tierBtn.setAttribute('aria-checked', 'true');
        var size = parseInt(tierBtn.getAttribute('data-size'), 10) || 1;
        buy.setAttribute('data-tier', tierBtn.getAttribute('data-tier'));
        buy.setAttribute('data-size', size);
        buildSlots(size);
        recompute();
      });
    });

    buy.addEventListener('click', function (e) {
      var cb = e.target.closest('.ddg-colbtn');
      if (!cb || !buy.contains(cb)) return;
      var row = cb.closest('.ddg-colrow');
      if (row) { row.querySelectorAll('.ddg-colbtn').forEach(function (b) { b.classList.remove('active'); }); }
      cb.classList.add('active');
      recompute();
    });

    if (slotHost) { buildSlots(parseInt(buy.getAttribute('data-size'), 10) || 2); }
    recompute();
  }

  function initBundle() {
    document.querySelectorAll('[data-ddg-buy]').forEach(initOneBuy);
  }

  /* ---------- add to cart (Dawn cart drawer) ---------- */
  // items: array of { id, quantity } — one entry per colour in the pack.
  function addToCart(items, btn) {
    if (!items || !items.length) { window.location.href = (window.routes && routes.cart_url) || '/cart'; return; }
    var buynow = btn && btn.hasAttribute('data-ddg-buynow');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; }

    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch((window.routes && routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { // error
          window.location.href = (window.routes && routes.cart_url) || '/cart';
          return;
        }
        if (buynow) { window.location.href = '/checkout'; return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location.href = (window.routes && routes.cart_url) || '/cart'; })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; btn.innerHTML = original; } });
  }

  function initBuyButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ddg-add]');
      if (!btn) return;
      e.preventDefault();
      var items = [];
      var raw = btn.getAttribute('data-ddg-items');
      if (raw) {
        try { items = JSON.parse(raw); } catch (e2) { items = []; }
      } else {
        var vid = btn.getAttribute('data-variant-id'); // legacy single-variant fallback
        if (vid) items = [{ id: Number(vid), quantity: 1 }];
      }
      addToCart(items, btn);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.ddg-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement;
        var a = item.querySelector('.ddg-faq-a');
        var open = item.classList.contains('open');
        item.classList.toggle('open');
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- ambient hero loop: fade in when ready, pause off-screen ---------- */
  function initHeroVideo() {
    var vid = document.querySelector('.ddg-hero__video');
    if (!vid) return;
    if (reduce) { vid.removeAttribute('autoplay'); try { vid.pause(); } catch (e) {} return; }

    // Choose source + poster by screen size: phones get the light vertical clip, large
    // screens the hi-res landscape one. Done here (not <source>) so only one file loads.
    var dataSrc = vid.getAttribute('data-src');
    if (dataSrc && !vid.currentSrc && !vid.src) {
      var isDesktop = window.matchMedia('(min-width: 1000px)').matches;
      var desktopSrc = vid.getAttribute('data-src-desktop');
      vid.src = (isDesktop && desktopSrc) ? desktopSrc : dataSrc;
      var posterD = vid.getAttribute('data-poster-desktop'), posterM = vid.getAttribute('data-poster');
      if (isDesktop && posterD) { vid.poster = posterD; }
      else if (posterM) { vid.poster = posterM; }
    }

    vid.muted = true;           // iOS needs the muted PROPERTY set, not just the attribute
    vid.defaultMuted = true;    // keeps the muted attribute from being dropped
    vid.setAttribute('muted', '');
    function tryPlay() { var p = vid.play(); if (p && p.catch) { p.catch(function () {}); } }

    tryPlay();
    vid.addEventListener('canplay', tryPlay);
    vid.addEventListener('loadeddata', tryPlay);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tryPlay(); });

    // iOS Low Power / Low Data Mode refuse autoplay until the user interacts. Kick
    // playback on the very first interaction so the loop starts without needing the
    // native play button. touchend is the most reliable iOS media gesture.
    var kicked = false;
    function kick() {
      if (kicked) return; kicked = true;
      tryPlay();
      ['touchend', 'touchstart', 'pointerdown', 'scroll', 'click'].forEach(function (ev) {
        window.removeEventListener(ev, kick);
      });
    }
    ['touchend', 'touchstart', 'pointerdown', 'scroll', 'click'].forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true });
    });

    // Don't burn CPU/battery animating a hero the viewer has scrolled past.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { tryPlay(); }
          else { try { vid.pause(); } catch (e) {} }
        });
      }, { threshold: 0.01 }).observe(vid);
    }
  }

  function init() {
    initReveal();
    initScroll();
    initBundle();
    initBuyButtons();
    initFaq();
    initPopup();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init pieces when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initBundle(); initFaq(); initHeroVideo();
  });
})();
